// extracted by mini-css-extract-plugin
export default {"row":"couponRow_row__9kF1m"};